<div class="notifications-container fxl-column fxla-space-between-stretch-mw">
  <div class="notifications-length fxl-row fxla-start-center">
    <button (click)="closeClickedHandler()" class="close-button" mat-icon-button>
      <mat-icon class="s-16">arrow_forward_ios</mat-icon>
    </button>
    <div class="notification-title fxf-auto-fill-r">
      @if (!notifications || notifications.length === 0) {
        <div>{{ title }}</div>
      }
      @if (notifications?.length === 1) {
        <div>{{ notifications.length }} notification</div>
      }
      @if (notifications?.length > 1) {
        <div>{{ notifications.length }} notifications</div>
      }
    </div>
  </div>
  <div class="notifications-list fxf-1-1-auto-c">
    <app-pdf-viewer #_pdfViewerComponent></app-pdf-viewer>
    @for (notification of notifications; track notification.uuid) {
      <div>
        @if (notification.discriminator === 'DocoonInboundFlow') {
          <app-docoon-inbound-flow-notification-card
            (closeEvent)="deleteNotificationClickedHandler(notification)"
            (previewPurchaseCreditsButtonEvent)="previewPurchaseCreditsButtonClickedHandler($any(notification))"
            (previewPurchaseInvoicesButtonEvent)="previewPurchaseInvoicesButtonClickedHandler($any(notification))"
            [docoonInboundFlowNotificationCard]="$any(notification)"
          >
          </app-docoon-inbound-flow-notification-card>
        }
        @if (notification.discriminator === 'ExportAll') {
          <app-export-all-notification-card
            (closeEvent)="deleteNotificationClickedHandler(notification)"
            (downloadAllButtonEvent)="downloadAllButtonClickedHandler(notification.uuid)"
            [exportAllNotificationCard]="$any(notification)"
          >
          </app-export-all-notification-card>
        }
        @if (notification.discriminator === 'Journal') {
          <app-journal-notification-card
            (closeEvent)="deleteNotificationClickedHandler(notification)"
            (downloadJournalFecButtonEvent)="downloadJournalFecButtonClickedHandler(notification.uuid)"
            (downloadJournalPdfButtonEvent)="downloadJournalPdfButtonClickedHandler(notification.uuid)"
            (downloadJournalSpreadsheetButtonEvent)="downloadJournalSpreadsheetButtonClickedHandler(notification.uuid)"
            (openJournalPdfButtonEvent)="openJournalPdfButtonClickedHandler(notification.uuid)"
            [journalNotificationCard]="$any(notification)"
          >
          </app-journal-notification-card>
        }
        @if (notification.discriminator === 'PdfMerge') {
          <app-pdf-merge-notification-card
            (closeEvent)="deleteNotificationClickedHandler(notification)"
            (downloadMergedPdfButtonEvent)="downloadMergedPdfButtonClickedHandler(notification.uuid)"
            (downloadZipButtonEvent)="downloadZipButtonClickedHandler(notification.uuid)"
            (openMergedPdfButtonEvent)="openMergedPdfButtonClickedHandler(notification.uuid)"
            [pdfMergeNotification]="$any(notification)"
          >
          </app-pdf-merge-notification-card>
        }
        @if (
          notification.discriminator === 'SpreadsheetExport' && notification.spreadsheetExportFileType === spreadsheetExportFileType.Xlsx
        ) {
          <app-spreadsheet-export-xlsx-notification-card
            (closeEvent)="deleteNotificationClickedHandler(notification)"
            (downloadSpreadsheetButtonEvent)="downloadSpreadsheetButtonClickedHandler(notification.uuid)"
            [spreadsheetExportNotificationCard]="$any(notification)"
          >
          </app-spreadsheet-export-xlsx-notification-card>
        }
        @if (
          notification.discriminator === 'SpreadsheetExport' && notification.spreadsheetExportFileType === spreadsheetExportFileType.Pdf
        ) {
          <app-spreadsheet-export-pdf-notification-card
            (closeEvent)="deleteNotificationClickedHandler(notification)"
            (downloadSpreadsheetButtonEvent)="downloadSpreadsheetButtonClickedHandler(notification.uuid)"
            (openSpreadsheetButtonEvent)="openSpreadsheetButtonClickHandler(notification.uuid)"
            [spreadsheetExportNotificationCard]="$any(notification)"
          >
          </app-spreadsheet-export-pdf-notification-card>
        }
        @if (notification.discriminator === 'SpreadsheetDashboard') {
          <app-spreadsheet-dashboard-notification-card
            (closeEvent)="deleteNotificationClickedHandler(notification)"
            (downloadSpreadsheetButtonEvent)="downloadSpreadsheetDashboardButtonClickedHandler(notification.uuid)"
            [spreadsheetDashboardNotificationCard]="$any(notification)"
          >
          </app-spreadsheet-dashboard-notification-card>
        }
      </div>
    }
  </div>
  @if (notifications?.length > 0) {
    <button
      (click)="deleteAllNotificationsClickedHandler()"
      class="erase-notifications-button"
      color="primary"
      mat-raised-button
      type="button"
    >
      Supprimer toutes les notifications
    </button>
  }
</div>
